import { Component } from "react";
import ICatalog from "../../../../../models/ICatalog";
import ISupplierModel from "../../../../../models/ISupplierModel";
import IUserUI from "../../../../../models/IUserUI";
import CategorySelection from "../../../../catalogs/CatalogOverview/CreateCatalogItemSidebar/CategorySelection/CategorySelection";
import { Socket } from "socket.io-client";

type Props = {
    catalogModel: ICatalog;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    socket: Socket;
    validCategorySelectionFn: (isValidCategorySelection: boolean) => void;
    setCategoryId: (id: number) => void;
};

type State = {};

class OrderCategorySelector extends Component<Props, State> {
    setCategoryId = (id: number) => {
        console.log("OrderCatSel: ", id);
        this.props.setCategoryId(id);
    };

    render() {
        if (!this.props.catalogModel) {
            return null;
        }

        return (
            <div className="OrderCategorySelector">
                <CategorySelection
                    socket={this.props.socket}
                    userModel={this.props.userModel}
                    supplierModel={this.props.supplierModel}
                    setCategoryId={this.setCategoryId}
                    catalogItem={undefined}
                    catalogGuid={this.props.catalogModel.guid}
                    requiredCategories={this.props.catalogModel.reqd_order_categories}
                />
            </div>
        );
    }
}

export default OrderCategorySelector;
